import React from 'react';
import SwipeableViews from 'react-swipeable-views';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';

import styles from './SparkOthers.module.scss';
import Challenges from './Challenges';
import Clues from './Clues';
import AdditionalFuns from './AdditionalFuns';

export default class SparkOthers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: 0,
    };
  }

  onChangeTab = (event, tab) => {
    this.setState({ tab: tab });
  };

  onChangeTabIndex = (index) => {
    this.setState({ tab: index });
  };

  render() {
    const { tab = -1 } = this.state;
    const {
      challenges = [],
      challengeMedia,
      clues = [],
      clueMedia,
      additionalFuns = [],
      additionalFunMedia,
      onSaveChallengeFunc,
      onSaveClueFunc,
      onSaveAdditionalFunsFunc,
      uploadMediaFunc,
      spark,
    } = this.props;
    return (
      <div className={styles.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={tab}
            onChange={this.onChangeTab}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab
              label="Challenges"
              style={{
                backgroundColor: 'white',
                textTransform: 'none',
                fontSize: '16px',
              }}
            />
            <Tab
              label="Clues/Additional Fun"
              style={{
                backgroundColor: 'white',
                textTransform: 'none',
                fontSize: '16px',
              }}
            />
          </Tabs>
        </AppBar>
        <SwipeableViews axis="x" index={tab} onChangeIndex={this.onChangeTabIndex}>
          <Challenges
            challenges={challenges}
            spark={this.props.spark}
            media={challengeMedia}
            onSaveChallengeFunc={onSaveChallengeFunc}
            uploadMediaFunc={uploadMediaFunc}
          />
          <div className={styles.root}>
            <Clues
              clues={clues}
              media={clueMedia}
              onSaveClueFunc={onSaveClueFunc}
              uploadMediaFunc={uploadMediaFunc}
              spark={spark}
            />
            <AdditionalFuns
              additionalFuns={additionalFuns}
              media={additionalFunMedia}
              onSaveAdditionalFunsFunc={onSaveAdditionalFunsFunc}
              uploadMediaFunc={uploadMediaFunc}
            />
          </div>
        </SwipeableViews>
      </div>
    );
  }
}
